export enum FlowType {
  REGULAR,
  LAND,
  COMMERCIAL,
}
